import { intl } from 'di18n-react';
export let AlarmLevel = /*#__PURE__*/function (AlarmLevel) {
  AlarmLevel[AlarmLevel["\u7279\u522B\u4E25\u91CD"] = 1] = "\u7279\u522B\u4E25\u91CD";
  AlarmLevel[AlarmLevel["\u4E25\u91CD"] = 2] = "\u4E25\u91CD";
  AlarmLevel[AlarmLevel["\u8F83\u91CD"] = 3] = "\u8F83\u91CD";
  AlarmLevel[AlarmLevel["\u4E00\u822C"] = 4] = "\u4E00\u822C";
  return AlarmLevel;
}({});
export let AlarmLevelColor = /*#__PURE__*/function (AlarmLevelColor) {
  AlarmLevelColor[AlarmLevelColor["#DF1F1A"] = 1] = "#DF1F1A";
  AlarmLevelColor[AlarmLevelColor["#FD9A01"] = 2] = "#FD9A01";
  AlarmLevelColor[AlarmLevelColor["#E3D700"] = 3] = "#E3D700";
  AlarmLevelColor[AlarmLevelColor["#145CD3"] = 4] = "#145CD3";
  return AlarmLevelColor;
}({});
export let StateEnum = /*#__PURE__*/function (StateEnum) {
  StateEnum["FAILED"] = "1";
  StateEnum["WAIT"] = "2";
  StateEnum["PENDING"] = "3";
  StateEnum["SUCCESS"] = "4";
  return StateEnum;
}({});
export const NodeState = {
  [StateEnum.FAILED]: intl.t('失败'),
  [StateEnum.WAIT]: intl.t('未集成'),
  [StateEnum.PENDING]: intl.t('集成中'),
  [StateEnum.SUCCESS]: intl.t('已集成')
};
export let AidHeartbeatState = /*#__PURE__*/function (AidHeartbeatState) {
  AidHeartbeatState[AidHeartbeatState["\u8FDE\u63A5\u65AD\u5F00"] = 0] = "\u8FDE\u63A5\u65AD\u5F00";
  AidHeartbeatState[AidHeartbeatState["\u8FDE\u63A5\u6B63\u5E38"] = 1] = "\u8FDE\u63A5\u6B63\u5E38";
  return AidHeartbeatState;
}({});
export let AidHeartbeatStateColor = /*#__PURE__*/function (AidHeartbeatStateColor) {
  AidHeartbeatStateColor[AidHeartbeatStateColor["#f53f3f"] = 0] = "#f53f3f";
  AidHeartbeatStateColor[AidHeartbeatStateColor["#478F43"] = 1] = "#478F43";
  return AidHeartbeatStateColor;
}({});
export const ConnectModel = {
  0: intl.t('普通模式')
};
export const developerCanceler = 'developer use Canceler';
export const sortDirect = new Map([[undefined, false], ['descend', false], ['ascend', true]]);
// 升序 true 一般的在前面 (时间：小/旧的在前面)
// 降序 false 特别严重的在前面

export const IntegrateType = {
  0: 'AIDLUX',
  1: 'BMC',
  2: 'YUN'
};
export let VersionTypeCodeEnum = /*#__PURE__*/function (VersionTypeCodeEnum) {
  VersionTypeCodeEnum[VersionTypeCodeEnum["COMMERCIAL_ROM"] = 1] = "COMMERCIAL_ROM";
  VersionTypeCodeEnum[VersionTypeCodeEnum["COMMERCIAL"] = 2] = "COMMERCIAL";
  return VersionTypeCodeEnum;
}({});
export const VersionTypeCode2Name = {
  [VersionTypeCodeEnum.COMMERCIAL_ROM]: intl.t('商业ROOT版'),
  [VersionTypeCodeEnum.COMMERCIAL]: intl.t('商业版')
};
export let VersionTypeNameEnum = /*#__PURE__*/function (VersionTypeNameEnum) {
  VersionTypeNameEnum["COMMERCIAL_ROM"] = "\u5546\u4E1AROOT\u7248";
  VersionTypeNameEnum["COMMERCIAL"] = "\u5546\u4E1A\u7248";
  return VersionTypeNameEnum;
}({});
export const VersionTypeName2Code = {
  [VersionTypeNameEnum.COMMERCIAL_ROM]: 1,
  [VersionTypeNameEnum.COMMERCIAL]: 2
};
export let VersionOperationTypeEnum = /*#__PURE__*/function (VersionOperationTypeEnum) {
  VersionOperationTypeEnum[VersionOperationTypeEnum["PATH_CURRENT_VERSION"] = 1] = "PATH_CURRENT_VERSION";
  // 升级路径中的当前版本
  VersionOperationTypeEnum[VersionOperationTypeEnum["PATH_TARGET_VERSION"] = 2] = "PATH_TARGET_VERSION";
  // 升级路径列表中的 目标版本
  VersionOperationTypeEnum[VersionOperationTypeEnum["PACKAGE_VERSION"] = 3] = "PACKAGE_VERSION"; // 软件包列表中的 软件版本
  return VersionOperationTypeEnum;
}({});
export let YesNoCodeEnum = /*#__PURE__*/function (YesNoCodeEnum) {
  YesNoCodeEnum[YesNoCodeEnum["YES"] = 1] = "YES";
  YesNoCodeEnum[YesNoCodeEnum["NO"] = 2] = "NO";
  return YesNoCodeEnum;
}({});
export const YesNoCode2Name = {
  [YesNoCodeEnum.YES]: intl.t('是'),
  [YesNoCodeEnum.NO]: intl.t('否')
};
export let YesNoNameEnum = /*#__PURE__*/function (YesNoNameEnum) {
  YesNoNameEnum["YES"] = "\u662F";
  YesNoNameEnum["NO"] = "\u5426";
  return YesNoNameEnum;
}({});
export const YesNoName2Code = {
  [YesNoNameEnum.YES]: 1,
  [YesNoNameEnum.NO]: 2
};
export let DeleteClassEnum = /*#__PURE__*/function (DeleteClassEnum) {
  DeleteClassEnum[DeleteClassEnum["DELETE_FROM_Table"] = 1] = "DELETE_FROM_Table";
  DeleteClassEnum[DeleteClassEnum["DELETE_FROM_CANCEL"] = 2] = "DELETE_FROM_CANCEL";
  return DeleteClassEnum;
}({});